import CustomerInvoices from "../../views/Invoices/CustomerInvoices";

const CustomerInvoicesPage = () => {
  return <CustomerInvoices />;
};

export default CustomerInvoicesPage;
